module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {}, [_c('a', {
    staticClass: "logo",
    class: {
      'hide': !_vm.sidebar.opened
    },
    attrs: {
      "href": "javascript:void(0)"
    }
  }, [_vm._v("\n        俺来也合作平台\n    ")]), _vm._v(" "), _c('span', {
    staticClass: "hide-menu cursor",
    on: {
      "click": _vm.toggleSideBar
    }
  }, [_c('i', {
    staticClass: "iconfont icon-menu"
  })]), _vm._v(" "), _c('el-menu', {
    staticClass: "el-menu-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "mode": "horizontal",
      "text-color": "#fff"
    }
  }, [_c('el-submenu', {
    attrs: {
      "index": "2"
    }
  }, [_c('template', {
    slot: "title"
  }, [(_vm.avatar) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": _vm.avatar,
      "width": "35",
      "height": "35"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.avatar) ? _c('img', {
    staticClass: "avatar",
    attrs: {
      "src": require("../images/default-avatar.png"),
      "width": "35",
      "height": "35"
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "rgba(0, 0, 0, 0.65)"
    }
  }, [_vm._v(_vm._s(_vm.username) + _vm._s(_vm.accountInfo.pid == 0 ? '' : '[子账号]'))])]), _vm._v(" "), (_vm.accountInfo.pid == 0) ? _c('el-menu-item', [_c('i', {
    staticClass: "el-icon-document"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/passport/account"
    }
  }, [_vm._v("账号管理")])], 1) : _vm._e(), _vm._v(" "), _c('el-menu-item', [_c('i', {
    staticClass: "el-icon-setting"
  }), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/passport/changepwd"
    }
  }, [_vm._v("修改密码")])], 1), _vm._v(" "), _c('el-menu-item', {
    on: {
      "click": function($event) {
        return _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "iconfont icon-loginout pr10"
  }), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#333"
    }
  }, [_vm._v("退出")])])], 2)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0ea159ce"}!./~/vue-loader/lib/selector.js?type=template&index=0!./vue/components/Header.vue
// module id = 883
// module chunks = 0